module.exports = __webpack_public_path__ + "static/p113-6cbd8da80866b34edc8d5bb43034c67f.png";